<template>
  <div
    v-if="
      (action === ACCIONES_TARJETA_RESERVA.CANCEL && reserva.estado !== ESTADOS_RESERVA.CANCELADA) ||
      (action === ACCIONES_TARJETA_RESERVA.RECOVER && reserva.estado === ESTADOS_RESERVA.CANCELADA) ||
      action === ACCIONES_TARJETA_RESERVA.PAY
    "
    class="card_pago text-primary w-100 rounded-12"
    :class="{
      'card_pago-selected': isPayActive || (action === ACCIONES_TARJETA_RESERVA.CANCEL && selectable && selected),
      'card-pago-pay': action === ACCIONES_TARJETA_RESERVA.PAY && fromMisReservas,
      pointer: selectable,
    }"
    @click="selectable && $emit('toggle')">
    <div
      class="card_pago-header d-flex align-items-center px-3 py-2 gap-10"
      :class="{
        'card_pago-header-selected': isPayActive || (action === ACCIONES_TARJETA_RESERVA.CANCEL && selectable && selected),
      }">
      <span v-if="selectable" class="selection-check" :class="{ 'selection-check-checked': selected }">
        <i v-if="selected" class="fa-solid fa-check sub" />
      </span>
      <span v-if="reserva.nombreUsuario" class="avatar-inicial small bold">{{
        reserva.nombreUsuario[0].toUpperCase()
      }}</span>
      <span class="p medium text-primary mb-0 flex-grow-1">{{ reserva.nombreUsuario }}</span>
    </div>

    <div class="p-15 d-flex flex-column gap-10">
      <template v-if="action === ACCIONES_TARJETA_RESERVA.CANCEL && reserva.estado !== ESTADOS_RESERVA.CANCELADA">
        <template v-if="reserva.totalPagado !== reserva.precioTotal">
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">{{ $t('reserva.totalPendiente') }}</span>
            <span class="p semibold text-secondary">
              {{ formatPrice(reserva.totalPagado) }} {{ agenciaStore.getCurrency }}
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">
              <i18n-t keypath="reserva.gastoCancelacion" tag="span">
                <template #fechaHoy>
                  <span>{{ todayDate }}</span>
                </template>
              </i18n-t>
            </span>
            <span class="p semibold text-secondary">
              {{ formatPrice(gastoCancelacion) }} {{ agenciaStore.getCurrency }}
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">{{ $t('reserva.saldoPendiente') }}</span>
            <span class="p semibold text-secondary">
              {{ formatPrice(calculateTotal(reserva.totalPagado, gastoCancelacion)) }}
              {{ agenciaStore.getCurrency }}
            </span>
          </div>
        </template>
        <template v-else>
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">{{ $t('reserva.pagoTotal') }}</span>
            <span class="p semibold text-secondary">
              {{ formatPrice(reserva.totalPagado) }} {{ agenciaStore.getCurrency }}
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">
              <i18n-t keypath="reserva.gastoCancelacion" tag="span">
                <template #fechaHoy>
                  <span>{{ todayDate }}</span>
                </template>
              </i18n-t>
            </span>
            <span class="p semibold text-secondary">
              {{ formatPrice(gastoCancelacion) }} {{ agenciaStore.getCurrency }}
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="p text-primary">{{ $t('reserva.totalDevolver') }}</span>
            <span class="p semibold text-secondary">
              {{ formatPrice(totalDevolver) }} {{ agenciaStore.getCurrency }}
            </span>
          </div>
        </template>
      </template>

      <template v-else-if="action === ACCIONES_TARJETA_RESERVA.PAY && fromMisReservas">
        <div class="d-flex justify-content-between align-items-center gap-10">
          <span class="p text-primary">{{ $t('reserva.totalReserva') }}</span>
          <span class="p semibold text-secondary">
            {{ formatPrice(reserva.precioTotal) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
        <div class="d-flex justify-content-between align-items-center gap-10">
          <span class="p text-primary">{{ $t('reserva.totalPagado') }}</span>
          <span class="p semibold text-secondary">
            {{ formatPrice(reserva.totalPagado) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
        <div class="d-flex justify-content-between align-items-center gap-10">
          <span class="p text-primary">{{ $t('subtitulo.totalPagar') }}</span>
          <span class="p semibold text-secondary">
            {{ formatPrice(totalPendiente) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
      </template>

      <template v-else-if="(action === ACCIONES_TARJETA_RESERVA.RECOVER && reserva.estado === ESTADOS_RESERVA.CANCELADA) || (action === ACCIONES_TARJETA_RESERVA.PAY && !fromMisReservas)">
        <div class="row w-100 pt-2">
          <div class="col bold pb-2">
            {{ $t('reserva.paqueteBasico') }}
          </div>
          <div class="col-auto text-secondary bold">
            {{ formatPrice(reserva.precioBasico) }} {{ agenciaStore.getCurrency }}
          </div>
        </div>

        <div v-for="incluye in grupo.viaje.incluyes" :key="incluye.id" class="row w-100">
          <div class="col">
            {{ incluye.nombre }}
          </div>
        </div>
        <div
          v-for="servicio in reserva.serviciosWithCantidad.map(swc => swc.servicio)"
          :key="servicio.id"
          class="row w-100">
          <div class="col">
            {{ servicio.nombre }}({{ servicio.numDias }}
            <span v-if="servicio.numDias === 1"> {{ $t('general.dia') }}</span>
            <span v-else> {{ $t('general.dias') }}</span
            >)
          </div>

          <div v-if="servicio.precio !== 0" class="col-auto text-secondary bold">
            <span>{{ formatPrice(servicio.precio) }} {{ agenciaStore.getCurrency }}</span>
          </div>
        </div>

        <template v-if="hasReservaSumplementos">
          <div class="col-12 bold text-primary py-2">
            {{ $t('reserva.suplementosGastos') }}
          </div>
          <div v-for="gasto in reserva.gastos" :key="gasto.id" class="row w-100">
            <div class="col">
              {{ gasto.concepto }}
            </div>

            <div class="col-auto text-secondary bold">
              <template v-if="gasto.importe !== 0">
                <span>{{ formatPrice(gasto.importe) }} {{ agenciaStore.getCurrency }}</span>
              </template>
            </div>
          </div>
          <div v-for="tasa in reserva.tasasExternas" :key="tasa.id" class="row w-100">
            <div class="col">
              {{ $t(`reserva.tasas.externas.${tasa.codigo}`) }}
            </div>

            <div class="col-auto text-secondary bold">
              <template v-if="tasa.importe !== 0">
                <span>{{ formatPrice(tasa.importe) }} {{ agenciaStore.getCurrency }}</span>
              </template>
            </div>
          </div>
          <template v-if="grupo.viaje.repercutirFee">
            <div v-for="tasa in reserva.tasasInternas" :key="tasa.id" class="row w-100">
              <div class="col">
                {{ $t(`reserva.${tasa.concepto}`) }}
              </div>

              <div class="col-auto text-secondary bold">
                <template v-if="tasa.importe !== 0">
                  <span>{{ formatPrice(tasa.importe) }} {{ agenciaStore.getCurrency }}</span>
                </template>
              </div>
            </div>
          </template>
        </template>

        <template v-if="reserva.complementos && reserva.complementos.length > 0">
          <div class="col-12 bold text-primary py-2">
            {{ $t('reserva.complementos') }}
          </div>
          <div v-for="complemento in reserva.complementos" :key="complemento.id" class="row w-100">
            <div class="col">
              {{ $t(`reserva.gastos.${complemento.concepto}`) }}
            </div>
            <div class="col-auto text-secondary bold">
              <template v-if="complemento.importe !== 0">
                <span>{{ formatPrice(complemento.importe) }} {{ agenciaStore.getCurrency }}</span>
              </template>
            </div>
          </div>
        </template>
        <template v-if="reserva.pagos.length > 0 && !fromMisReservas">
          <div class="col-12 bold text-primary py-2">{{ $t('general.pagos') }}</div>
          <div v-for="p in reserva.pagos" :key="p" class="row w-100">
            <div class="col">{{ p.concepto }}</div>

            <div class="col-auto text-secondary bold">
              <template v-if="p.cantidad !== 0">
                <span>- {{ formatPrice(p.cantidad) }} {{ agenciaStore.getCurrency }}</span>
              </template>
            </div>
          </div>
        </template>
        <hr class="line-divider pt-2" />
        <div v-if="!fromMisReservas" class="row w-100 text-description">
          <div class="col-6">{{ $t('subtitulo.total') }}</div>
          <div class="col text-end">{{ formatPrice(totalPendiente) }} {{ agenciaStore.getCurrency }}</div>
        </div>
        <div v-else class="row w-100 text-description">
          <div class="col-6 bold">{{ $t('subtitulo.total') }}</div>
          <div class="col text-end bold text-secondary">
            {{ formatPrice(reserva.precioTotal) }} {{ agenciaStore.getCurrency }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { normalizeDate } from '@/helpers/dateUtiles';
  import { formatPrice } from '@/helpers/numberUtils';
  import { ESTADOS_RESERVA, ACCIONES_TARJETA_RESERVA } from '@/constants/reservaConstants';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import moment from 'moment-timezone';
  import currency from 'currency.js';

  const props = defineProps({
    reserva: {
      type: Object,
      default: () => ({}),
    },
    grupo: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: String,
      default: '',
    },
    fromMisReservas: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(['toggle']);

  const agenciaStore = agenciaStoreModule();

  const isPayActive = computed(
    () =>
      props.action === ACCIONES_TARJETA_RESERVA.PAY &&
      props.fromMisReservas &&
      (props.selectable ? props.selected : true)
  );
  const todayDate = computed(() => moment().format('DD-MM-YYYY'));
  const hasReservaSumplementos = computed(
    () =>
      (props.reserva.tasasInternas.length > 0 && props.grupo.viaje.repercutirFee) ||
      props.reserva.tasasExternas.length > 0 ||
      props.reserva.gastos.length > 0
  );

  const gastoCancelacion = computed(() => {
    if (!props.grupo.politicaCancelacion) return 0;

    const tramos = props.grupo.politicaCancelacion.tramos || [];
    if (tramos.length === 0) return 0;

    const hoy = moment().startOf('day');
    const ultimoTramoFechaFin = normalizeDate(tramos[tramos.length - 1].fechaFin);

    for (const tramo of tramos) {
      const inicio = normalizeDate(tramo.fechaInicio);
      const fin = normalizeDate(tramo.fechaFin);

      if (hoy >= inicio && hoy <= fin) {
        return tramo.porcentaje > 0 ? currency((props.reserva.precioTotal * tramo.porcentaje) / 100).value : 0;
      }
    }
    if (hoy > ultimoTramoFechaFin) {
      return props.reserva.precioTotal;
    }

    return 0;
  });

  const totalDevolver = computed(() => currency(props.reserva.totalPagado).subtract(gastoCancelacion.value));
  const totalPendiente = computed(() => currency(props.reserva.precioTotal).subtract(props.reserva.totalPagado));
  function calculateTotal(totalPagado, gastoCancelacion) {
    if (totalPagado < gastoCancelacion) {
      return currency(gastoCancelacion).subtract(totalPagado);
    } else {
      return currency(totalPagado).subtract(gastoCancelacion);
    }
  }
</script>

<style lang="css" scoped>
  .card_pago {
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    overflow: hidden;
  }

  .card_pago-selected {
    border-color: var(--bs-secondary);
  }

  .card_pago-header {
    background-color: rgba(var(--bs-primary-rgb), 0.1);
  }

  .card_pago-header-selected {
    background-color: rgba(var(--bs-secondary-rgb), 0.1);
  }

  .selection-check {
    width: 15px;
    height: 15px;
    min-width: 15px;
    border-radius: 8px;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.4);
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .selection-check-checked {
    background-color: var(--bs-secondary);
    border-color: var(--bs-secondary);
  }

  .avatar-inicial {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    border: 1.5px solid var(--bs-secondary);
    background-color: var(--bs-primary);
    color: var(--bs-secondary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .card-pago-pay .card-pago-importe {
    white-space: nowrap;
  }
</style>
